import { HeaderTitle } from '@/components/atoms'
import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable'
import { Header } from '@/utils/constants/header'
import { useState } from 'react'
import './ProductsTable.scss'

const ProductsTable = props => {
  const {
    columns = [],
    records = [],
    isUploadTable = false,
    handleBulkAction = () => { },
    setPageIndex = () => { },
    setSearchArry = () => { },
    searchState = [],
    setSortingObj = () => { },
    pageIndex = 0,
    productListData,
    handleResetAll = () => { },
    isLoading = false,
    setRowSelection,
    rowSelection = [],
    fetchAllProducts,
  } = props

  const [isSelectAll, setIsSelectAll] = useState(false)

  return (
    <div className="productsTable relative px-5" style={{ backgroundColor: '#1D1D1D' }} data-testid="products-table">
      <HeaderTitle
        headingLevel={Header.SectionTitle}
        title="Select Products to Include or Exclude"
        className="pl-6 pr-4 pt-6 text-lg font-bold"
      />

      <CustomDataTable
        columns={columns}
        records={records || []}
        isLoading={isLoading}
        pageSize={10}
        totalRecords={productListData?.totalRecords || 0}
        setPageIndex={setPageIndex}
        handleSorting={setSortingObj}
        setSearchArry={setSearchArry}
        onResetAll={handleResetAll}
        onRowSelect={(selectedRecords, isAll) => {
          setRowSelection(selectedRecords)
          setIsSelectAll(isAll)
        }}
        initialRowSelection={rowSelection}  
        toolbarActions={
          isUploadTable
            ? []
            : [
              {
                id: 'include-btn',
                label: 'Include',
                variant: 'secondary',
                color: 'primary',
                requiresSelection: true,
                onClick: async () => {
                  await handleBulkAction(false, isSelectAll, fetchAllProducts, searchState)
                }
              },
              {
                id: 'exclude-btn',
                label: 'Exclude',
                variant: 'secondary',
                color: 'primary',
                requiresSelection: true,
                onClick: async () => {
                  await handleBulkAction(true, isSelectAll, fetchAllProducts, searchState)
                }
              }
            ]
        }
        isSelectAll={isSelectAll}
        pageIndex={pageIndex}
      />
    </div>
  )
}

export default ProductsTable
